import React, { useEffect } from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { Field, reduxForm, FieldArray } from 'redux-form'
import { getRights } from '../../state/rights'
import { getLists } from '../../state/lists'
import { useSelector } from 'react-redux'

import {
    FormButtons,
    validations,
    renderers,
    upperCase, ICONS,
} from '../../components'

const getFormItems = (enableBulkMode, descriptions) => {
  return enableBulkMode ? (
    <ReactBootstrap.Col>
      <FieldArray
        descriptions={descriptions}
        name="inventory_items"
        component={renderItems}
      />
    </ReactBootstrap.Col>
  ) : (
    <div>
      <Field
        name="serial_number"
        type="text"
        normalize={upperCase}
        validate={[validations.required]}
        component={renderers.renderField}
        label="Serial Number"
      />
      <Field
        name="po_number"
        type="text"
        validate={[validations.required]}
        component={renderers.renderField}
        label="PO Number"
      />
      <Field
        name="awb_number"
        type="text"
        validate={[validations.required]}
        component={renderers.renderField}
        label="AWB Number"
      />
    </div>
  )
}

const renderItems = ({ fields, meta: { error, submitFailed } }) => {
  if (fields.length === 0) {
    fields.push({})
  }
  return (
    <ReactBootstrap.Col className="mt-5 p-0">
      <ReactBootstrap.ListGroup>
        {fields.map((member, index) => (
          <ReactBootstrap.ListGroupItem key={index}>
            <ReactBootstrap.Row>
                 <ReactBootstrap.Col xs={12}>
              <ReactBootstrap.Button
                style={{ float: 'right' }}
                variant="danger"
                size="sm"
                onClick={() => fields.remove(index)}
              >
                  {ICONS.DELETE}
              </ReactBootstrap.Button>
                  </ReactBootstrap.Col>
              <ReactBootstrap.Col xs={12} md={4}>
                <Field
                  name={`${member}.serial_number`}
                  type="text"
                  normalize={upperCase}
                  validate={[validations.required]}
                  component={renderers.renderField}
                  placeholder="Serial Number"
                />
              </ReactBootstrap.Col>
              <ReactBootstrap.Col xs={12} md={4}>
                <Field
                  name={`${member}.po_number`}
                  type="text"
                  validate={[validations.required]}
                  component={renderers.renderField}
                  placeholder="PO Number"
                />
              </ReactBootstrap.Col>
              <ReactBootstrap.Col xs={12} md={4}>
                <Field
                  name={`${member}.awb_number`}
                  type="text"
                  validate={[validations.required]}
                  component={renderers.renderField}
                  placeholder="AWB Number"
                />
              </ReactBootstrap.Col>

            </ReactBootstrap.Row>
          </ReactBootstrap.ListGroupItem>
        ))}
        <ReactBootstrap.ListGroupItem>
          <ReactBootstrap.Button
            style={{ float: 'right' }}
            variant="outline-dark"
            size="sm"
            onClick={() => fields.push({})}
          >
              {ICONS.PLUS}
          </ReactBootstrap.Button>
          {submitFailed && error && <span>{error}</span>}
        </ReactBootstrap.ListGroupItem>
      </ReactBootstrap.ListGroup>
    </ReactBootstrap.Col>
  )
}
let LoanerInventoryForm = ({
  enableBulkMode,
  handleSubmit,
  pristine,
  reset,
  submitting,
  dispatch,
}) => {
  const { user } = useSelector((state) => state.auth)
  const { rights } = useSelector((state) => state.userRights)
  const { loaner_inventory_part_numbers } = useSelector((state) => state.lists)
  useEffect(() => {
    !rights && dispatch(getRights(user))
    !loaner_inventory_part_numbers &&
      dispatch(getLists('LOANER_INVENTORY_PART_NUMBERS'))
  }, [rights, loaner_inventory_part_numbers, dispatch, user])
  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Col xs="12">
        <Field
          component={renderers.renderSelectField}
          as="select"
          validate={[validations.required]}
          name="organization"
          label="Organization"
        >
          {rights &&
            rights
              .filter((x) => x.is_active && x.loaner_inventory === true)
              .map((opt) => (
                <option key={opt.organization_code} value={opt.organization}>
                  {opt.organization_code}-{opt.organization_name}
                </option>
              ))}
        </Field>

        <Field
          component={renderers.renderSelectField}
          as="select"
          validate={[validations.required]}
          name="part_number"
          label="Part Number"
        >
          {loaner_inventory_part_numbers &&
            loaner_inventory_part_numbers.map((part_number) => (
              <option key={part_number.url} value={part_number.value}>
                {part_number.value}
              </option>
            ))}
        </Field>

        <Field
          name="description"
          type="text"
          validate={[validations.required]}
          component={renderers.renderField}
          label="Description"
        />
      </ReactBootstrap.Col>

      {getFormItems(enableBulkMode)}
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
LoanerInventoryForm = reduxForm({
  // a unique name for the form
  form: 'loaner-inventory-form',
})(LoanerInventoryForm)

export default LoanerInventoryForm
